module.exports = __webpack_public_path__ + "static/media/promo3.a0b7fb1f.jpg";